/* SolNow — store de comentarios de tickets (Pinia), indexado por ticket. */
import { defineStore } from 'pinia';
import TicketCommentsAPI from 'dashboard/api/ticketComments';

export const useTicketCommentsStore = defineStore('ticketComments', {
  state: () => ({
    byTicket: {},
    isFetching: false,
    isCreating: false,
  }),

  getters: {
    forTicket: state => ticketId => state.byTicket[ticketId] || [],
  },

  actions: {
    upsert(comment) {
      const list = this.byTicket[comment.ticket_id] || [];
      if (list.some(c => c.id === comment.id)) return;
      this.byTicket[comment.ticket_id] = [...list, comment];
    },

    async fetch(ticketId) {
      this.isFetching = true;
      try {
        const { data } = await TicketCommentsAPI.getComments(ticketId);
        this.byTicket[ticketId] = data.payload || data;
      } finally {
        this.isFetching = false;
      }
    },

    async create(ticketId, content) {
      this.isCreating = true;
      try {
        const { data } = await TicketCommentsAPI.createComment(ticketId, content);
        this.upsert(data.payload || data);
        return data.payload || data;
      } finally {
        this.isCreating = false;
      }
    },
  },
});
